import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  if (items.length <= 1) return null;

  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      fontSize: 12,
      fontFamily: 'var(--font-primary)',
      marginBottom: 8,
      animation: 'fadeInUp 0.25s ease',
    }}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {i > 0 && (
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ color: 'var(--t3)', flexShrink: 0 }}>
                <path d="M4.5 2.5L7.5 6L4.5 9.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
            {isLast || !item.to ? (
              <span style={{
                color: isLast ? 'var(--t1)' : 'var(--t3)',
                fontWeight: isLast ? 600 : 400,
              }}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to}
                style={{
                  color: 'var(--t3)',
                  textDecoration: 'none',
                  transition: 'color 0.15s',
                }}
                onMouseEnter={(e) => { (e.target as HTMLElement).style.color = 'var(--accent)'; }}
                onMouseLeave={(e) => { (e.target as HTMLElement).style.color = 'var(--t3)'; }}
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
